<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>删除限制登录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <audit-list @refresh="refreshList"></audit-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import AuditList from './components/list';

export default {
  name: 'loglim',
  data() {
    return {};
  },
  components: {
    AuditList
  },
  computed: {},
  methods: {
    ...mapActions('logLim', ['list']),
    refreshList(){
      this.list()
    }
  },
  created() {
    this.list();
  }
};
</script>

<style lang="less" scoped></style>
